export const MAGPIE_CLIENT_LOGGER_NAME = 'magpie-lib';
export const WINDOW_BROKER_LOGGER_NAME = 'magpie-lib/window-broker';
export const WINDOW_BROKER_LOCATOR_LOGGER_NAME =
  'magpie-lib/window-broker/locator';
export const WINDOW_BROKER_PROXY_LOGGER_NAME = 'magpie-lib/window-broker-proxy';
export const WINDOW_BROKER_CONNECTOR_LOGGER_NAME =
  'magpie-lib/window-broker-connector';
export const WINDOW_BROKER_PROPERTY_NAME = Symbol.for(
  '@@magpie-lib/window-broker'
);
export const CROSS_TAB_LINK_LOGGER_NAME = '@@magpie-lib/cross-tab-link';

export const METRIC_NAMES = {
  MESSAGE_COUNT: 'message_count',
  MESSAGE_LATENCY: 'message_latency',
  VALIDATION_ERROR_COUNT: 'validation_error_count',
  CONNECTION_ERROR_COUNT: 'connection_error_count',
  HANDSHAKE_COMPLETED: 'handshake_completed',
  HANDSHAKE_LATENCY: 'handshake_latency',
} as const;
